<template>
  <layout-main-inner v-loading="loading">
    <div slot="action">
      <el-button
        type="primary"
        @click="additem">新增电子名片</el-button>
      <el-dropdown>
        <el-button
          type="info"
          style="margin-left: 10px;">
          更多<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="downloadtmp">下载模板</el-dropdown-item>
          <el-dropdown-item @click.native="uploadtmp">批量上传</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <layout-card-wrap hasSlot>
      <template slot="form">
        <el-input
          v-model="config.name"
          clearable
          placeholder="请输入姓名"
          @clear="handleCurrentChange(1)">
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="handleCurrentChange(1)"></el-button>
        </el-input>
      </template>
      <el-table
        border
        :data="list">
        <el-table-column
          label="姓名"
          fixed="left"
          min-width="80"
          prop="name"> </el-table-column>
        <el-table-column
          label="手机号"
          width="110"
          prop="mobilePhone"> </el-table-column>
        <el-table-column
          label="微信手机号"
          width="110"
          prop="wxMobilePhone">
        </el-table-column>
        <el-table-column
          label="固定电话"
          width="110"
          prop="phone"> </el-table-column>
        <el-table-column
          label="邮箱"
          min-width="120"
          prop="email"> </el-table-column>
        <el-table-column
          label="部门"
          min-width="120"
          prop="department"></el-table-column>
        <el-table-column
          label="职位"
          min-width="100"
          prop="position"></el-table-column>
        <el-table-column
          label="公司名称"
          min-width="160"
          prop="corpName"></el-table-column>
        <el-table-column
          label="公司地址"
          min-width="180"
          prop="corpAddress"></el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="100">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              @click="updateitem(row)">编辑</el-button>
            <el-button
              type="text"
              @click="deleteitem(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination-new
        v-model="config"
        :total="total"
        :fetch="fetchList" />
    </layout-card-wrap>
    <edit-address-book-modal
      ref="edit"
      @fetch="fetchList" />
    <el-upload
      ref="elUpload"
      action=""
      :limit="1"
      style="display: none;"
      accept=".xls,.xlsx"
      :show-file-list="false"
      :http-request="handleHttpRequest">
      <i ref="upload"></i>
    </el-upload>
  </layout-main-inner>
</template>
<script>
import EditAddressBookModal from './edit-address-book-modal.vue'
import Common from '@/service/common'
import { downloadBlobFile } from '@/utils/index'
export default {
  name: 'AddressBook',
  components: { EditAddressBookModal },
  data() {
    return {
      loading: true,
      list: [],
      total: 0,
      config: { pageNum: 1, pageSize: 10, name: '' }
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    downloadtmp() {
      this.loading = true
      Common.downloadnamecardtemplate({ })
        .then(res => {
          this.loading = false
          downloadBlobFile(res)
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    handleHttpRequest(file) {
      const formData = new FormData()
      formData.append('file', file.file)
      this.loading = true
      Common.uploadnamecard(formData)
        .then(res => {
          this.loading = false
          const { result, message } = res.data
          if ([0].includes(result)) {
            this.$message.success('上传成功')
            this.fetchList()
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    },
    uploadtmp() {
      this.$refs.upload.click()
    },
    updateitem(row) {
      this.$refs.edit.init(row)
    },
    additem(row) {
      this.$refs.edit.init(row)
    },
    deleteitem(row) {
      console.log(row)
      this.$confirm('您确定删除该名片?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          Common.deletenamecard({ nameCardId: row.nameCardId })
            .then(res => {
              this.loading = false
              const { result, message } = res.data
              if ([0].includes(result)) {
                this.$message.success('删除成功')
                this.fetchList()
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      Common.getnamecards({ ...this.config })
        .then(res => {
          this.loading = false
          const { result, message, total, records } = res.data
          if ([0].includes(result)) {
            this.total = total
            this.list = records
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
